import React, { lazy } from "react";
import { Route } from "react-router-dom";
import { RequireAuth } from "routes/utils";

const EmailSettings = lazy(() => import(/* webpackChunkName: "email-settings" */ "pages/account/email-settings"));
const Notifications = lazy(() => import(/* webpackChunkName: "notifications" */ "pages/account/notifications"));
const ChangePassword = lazy(() => import(/* webpackChunkName: "change-password" */ "pages/account/change-password"));
const PaymentInfo = lazy(() => import(/* webpackChunkName: "payment-info" */ "pages/account/payment-info"));
const MyAccount = lazy(() => import(/* webpackChunkName: "my-account" */ "pages/account/my-account"));
const Cancel = lazy(() => import(/* webpackChunkName: "cancel" */ "pages/account/cancel"));
const Unsubscribe = lazy(() => import(/* webpackChunkName: "unsubscribe" */ "pages/static/unsubscribe"));
const VerifyEmail = lazy(() => import(/* webpackChunkName: "verify-email" */ "pages/static/verify-email"));

const renderAccountRoutes = () => [
  <Route
    key="email-settings"
    name="email-settings"
    path="/email_settings"
    element={
      <RequireAuth redirectTo="/login?next=/email_settings" strict>
        <EmailSettings />
      </RequireAuth>
    }
  />,
  <Route
    key="my-account"
    name="my-account"
    path="/account"
    element={
      <RequireAuth redirectTo="/login?next=/account" strict>
        <MyAccount />
      </RequireAuth>
    }
  />,
  <Route
    key="notifications"
    name="notifications"
    path="/notifications"
    element={
      <RequireAuth redirectTo="/login?next=/notifications" strict>
        <Notifications />
      </RequireAuth>
    }
  />,
  <Route
    key="payment-info"
    name="payment-info"
    path="/payment"
    element={
      <RequireAuth redirectTo="/login?next=/payment" strict>
        <PaymentInfo />
      </RequireAuth>
    }
  />,
  <Route
    key="cancel"
    name="cancel"
    path="/account/cancel"
    element={
      <RequireAuth redirectTo="/login?next=/account/cancel" strict>
        <Cancel />
      </RequireAuth>
    }
  />,
  <Route
    key="change-password"
    name="change-password"
    path="/change_password"
    element={
      <RequireAuth redirectTo="/login?next=/change_password">
        <ChangePassword />
      </RequireAuth>
    }
  />,
  <Route key="unsubscribe" name="unsubscribe" path="/unsubscribe" element={<Unsubscribe />} />,
  <Route key="verify-email" name="verify-email" path="/verify" element={<VerifyEmail />} />,
];

export default renderAccountRoutes;
